import QueryService from '@/services/query'

import { VUE_APP_ROOT_API } from '@/helpers/env'
import i18n from '@/helpers/i18n'

import { SET_CONFIG } from '@/consts/store'
import Store from '@/stores/store'

export default {
  loadConfig: async function() {
    const response = await QueryService.get(`${VUE_APP_ROOT_API}/appconfigapi/export?lang=${i18n.locale()}`)
    let appConfig = await response.json()
    Store.commit(SET_CONFIG, appConfig)
  }
}
